import React, { useEffect, useState } from 'react';
import { View, FlatList, StyleSheet } from 'react-native';
import { getSpacing, ListEmpty, Text, useAlert } from '@rahtab/ui';
import { ListScreen } from '@rahtab/stack-navigator';
import SaleItem from './SaleItem';
import { useLogout } from '@rahtab/auth/lib/token-based-auth';
import AsyncStorage from '@react-native-async-storage/async-storage';
import PurchaseHistoryEmptyIcon from '@rahtab/ui/dist/icons/ListEmptyIcons/PurchaseHistory';

const SaleHistory = () => {
  const [loading, setLoading] = useState(false);
  const [localSaleHistory, setLocalSaleHistory] = useState<any[]>();
  const alert = useAlert();
  const { logout } = useLogout();
  const getSaleHistory = async () => {
    setLoading(true);
    const storedUsername = await AsyncStorage.getItem('username');
    if (storedUsername === null) {
      logout();
      alert({ message: 'لطفا دوباره وارد شوید.' });
      return false;
    }
    const histories = await AsyncStorage.getItem(`${storedUsername}-saleHistory`);
    if (histories !== null) {
      setLoading(false);
      console.log('sale history for you', storedUsername, localSaleHistory);
      setLocalSaleHistory(JSON.parse(histories));
    } else setLoading(false);
  };
  useEffect(() => {
    getSaleHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <ListScreen
      loading={loading}
      title="سوابق فروش فروشگاه"
      // data={localSaleHistory}
      listData={localSaleHistory}
      ListEmptyComponent={() => (
        <ListEmpty text="سابقه فروش وجود ندارد." imageComponent={<PurchaseHistoryEmptyIcon />} />
      )}
      keyExtractor={(item, index) => `saleHistory-${index}`}
      // contentContainerStyle={styles.containerStyle}
      renderItem={({ item }) => {
        return <SaleItem {...item} />;
      }}
    />
  );
};

export default SaleHistory;

const styles = StyleSheet.create({
  screen: {
    padding: getSpacing(),
  },
  containerStyle: {
    padding: getSpacing(0.5),
  },
});
